itsoftApp.createModule("video", function () {
    var firstVideo = document.querySelector(".js-video-item-1");
    var secondVideo = document.querySelector(".js-video-item-2");
    var textElement = document.querySelector(".intro__right");
    var videoWrapper = document.querySelector(".js-mobile-hide");

    var onVideoPlay = function () {
        var playPromise = firstVideo.play();

        if (playPromise !== undefined) {
            playPromise.then(_ => {
                setTimeout(function () {
                    videoWrapper.classList.remove("js-mobile-hide");
                }, 800);
                setTimeout(function () {
                    textElement.classList.add("js-show");
                }, 1700);
            })
            .catch(error => {
              console.log("video load error")
            });
        }
    }

    var onVideoEnded = function (evt) {
        secondVideo.play();
        secondVideo.classList.remove("js-hide");
        secondVideo.parentNode.removeChild(firstVideo);
        firstVideo.classList.add("js-hide");
    }

    if (firstVideo) {
        window.addEventListener("load", function () {
            setTimeout(function () {
                onVideoPlay();
            }, 300)
        });
        firstVideo.addEventListener("ended", onVideoEnded);
    }
});